/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    cancelButton: "Cancel",
    confirmButton: "Confirm",
    inputText: {
        placeholder: "e.g. Visit my site"
    },
    inputTextLabel: "Display text (optional)",
    linkModalLabel: "Insert Link"
};